import {WithSummaryModel} from '../../../../common/entity/dto/plain/withSummary.model';
import {CommunicationContentModelSummaryModel} from './communicationContentModelSummary.model';

export class CommunicationContentModelModel extends WithSummaryModel<CommunicationContentModelSummaryModel> {
    content: string;
}
